import { CUSTOMER_NEEDS, NEEDS_PRODUCT_TYPE_SLUG } from '@ahmdigital/constants';
import { difference, includes, map, max, reject } from 'lodash/fp';
import { FormikField, Tooltip } from '@ahmdigital/ui';

import { EXCESS_TYPES } from '../../../../../../ahm-constants/ui';
import { ExcessToggleValues } from '../../../../../../selectors/select-excess-toggle-values';
import { IsExcessToggleApplicableType } from '../../../../../../selectors/select-is-excess-toggle-applicable';
import { Match } from '../../../../types';

const hospitalExcessToOptions = (hospitalExcess: ExcessToggleValues, match?: Match) => {
  const excessForOptions = EXCESS_TYPES;
  const { needsType, needsProductType } = match?.params || {};

  // Currently only packages has a product with $0 excess, so we need to disable it for hospital and combined
  const filteredHospitalExcess =
    needsType === CUSTOMER_NEEDS.HOSPITAL_COVER ||
    includes(needsProductType, [NEEDS_PRODUCT_TYPE_SLUG.HOSPITAL, NEEDS_PRODUCT_TYPE_SLUG.COMBINED])
      ? reject((value) => value === 0, hospitalExcess)
      : hospitalExcess;

  const unavailableExcessTypes = difference(EXCESS_TYPES, filteredHospitalExcess);

  return map((value) => {
    const isDisabled = includes(value, unavailableExcessTypes);
    return {
      isDisabled,
      text: `$${value}`,
      value: `${value}`,
    };
  }, excessForOptions);
};

type ExcessToggleProps = {
  hospitalExcess: ExcessToggleValues;
  isExcessApplicable: IsExcessToggleApplicableType;
  match?: Match;
};

const ExcessToggle = ({ isExcessApplicable, hospitalExcess, match }: ExcessToggleProps) => {
  if (!isExcessApplicable) {
    return null;
  }

  const tooltip = (
    <Tooltip>
      An excess is an upfront lump sum payment that you agree to pay towards the cost of your hospital stay or day
      surgery. You can reduce your health insurance premium by opting for a ${max(hospitalExcess)} hospital excess per
      {/* @ts-expect-error - Automatic, Please fix when editing this file */}
      person (up to a maximum of ${max(hospitalExcess) * 2} per couple/family per Membership Year).
    </Tooltip>
  );

  return (
    <FormikField
      label="I want my hospital excess to be"
      name="hospitalExcess"
      size="auto"
      inputVariant={['button', 'fullWidth']}
      type="dropdown"
      options={hospitalExcessToOptions(hospitalExcess, match)}
      tooltip={tooltip}
    />
  );
};

export default ExcessToggle;
